import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Overview16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.5 5.25C7.80964 5.25 7.25 5.80964 7.25 6.5V9C7.25 9.69036 7.80964 10.25 8.5 10.25H11C11.6904 10.25 12.25 9.69036 12.25 9V6.5C12.25 5.80964 11.6904 5.25 11 5.25H8.5ZM8.75 8.75V6.75H10.75V8.75H8.75Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 1.25C4.27208 1.25 1.25 4.27208 1.25 8C1.25 9.59377 1.80236 11.0585 2.7261 12.2133L0.469727 14.4697L1.53039 15.5303L3.78676 13.2739C4.94151 14.1977 6.40625 14.75 8 14.75C11.7279 14.75 14.75 11.7279 14.75 8C14.75 4.27208 11.7279 1.25 8 1.25ZM2.89972 6.75H4.75V8.75H2.80317C2.70886 8.09069 2.74403 7.38744 2.89972 6.75ZM5 5.25H3.527C4.45119 3.74996 6.10882 2.75 8 2.75C10.8995 2.75 13.25 5.10051 13.25 8C13.25 10.8995 10.8995 13.25 8 13.25C5.9057 13.25 4.09782 12.0237 3.25522 10.25H5C5.69036 10.25 6.25 9.69036 6.25 9V6.5C6.25 5.80964 5.69036 5.25 5 5.25Z'
      fill='currentColor'
    />
  </Svg>
);

Overview16.displayName = 'Overview16';
export default Overview16;
